/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiPersonTransactionsSummary,
    ApiPersonTransactionsSummaryFromJSON,
    ApiPersonTransactionsSummaryToJSON,
    ApiTransactionSummaryByAccount,
    ApiTransactionSummaryByAccountFromJSON,
    ApiTransactionSummaryByAccountToJSON,
} from '../models';

export interface GetPersonAccountsAggregationRequest {
    personId: string;
    page: number;
    size: number;
    type: GetPersonAccountsAggregationTypeEnum;
    from?: Date;
    to?: Date;
}

export interface GetPersonTransactionsSummaryRequest {
    personId: string;
    from?: Date;
    to?: Date;
}

/**
 * 
 */
export class TransactionSummaryApi extends runtime.BaseAPI {

    /**
     * Fetches additional accounts aggregation
     */
    async getPersonAccountsAggregationRaw(requestParameters: GetPersonAccountsAggregationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiTransactionSummaryByAccount>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonAccountsAggregation.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getPersonAccountsAggregation.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getPersonAccountsAggregation.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling getPersonAccountsAggregation.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString();
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions-summary/accounts`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiTransactionSummaryByAccountFromJSON));
    }

    /**
     * Fetches additional accounts aggregation
     */
    async getPersonAccountsAggregation(requestParameters: GetPersonAccountsAggregationRequest, initOverrides?: RequestInit): Promise<Array<ApiTransactionSummaryByAccount>> {
        const response = await this.getPersonAccountsAggregationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches persons transactions summary
     */
    async getPersonTransactionsSummaryRaw(requestParameters: GetPersonTransactionsSummaryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiPersonTransactionsSummary>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonTransactionsSummary.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = (requestParameters.from as any).toISOString();
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = (requestParameters.to as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/transactions-summary`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiPersonTransactionsSummaryFromJSON(jsonValue));
    }

    /**
     * Fetches persons transactions summary
     */
    async getPersonTransactionsSummary(requestParameters: GetPersonTransactionsSummaryRequest, initOverrides?: RequestInit): Promise<ApiPersonTransactionsSummary> {
        const response = await this.getPersonTransactionsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetPersonAccountsAggregationTypeEnum {
    SENDER = 'SENDER',
    RECIPIENT = 'RECIPIENT'
}
